import * as actions from "../action.constants";

const requestSites = (reqPayload = {}, pageUrl = "") => ({
  type: actions.GET_SITES,
  reqPayload,
  pageUrl,
});

const saveSelectedSite = (selectedSite) => ({
  type: actions.STORE_SELECTED_SITE,
  selectedSite,
});

const getSiteAndLocationForFavouriteController = (siteId, locationId) => ({
  type: actions.GET_SITE_AND_LOCATION_FOR_FAVOURITE_CONTROLLER,
  siteId,
  locationId,
});

const requestLocations = (siteId) => ({
  type: actions.REQUEST_LOCATIONS,
  siteId,
});

const requestClaimController = (reqPayload, callback) => ({
  type: actions.CLAIM_CONTROLLER,
  reqPayload,
  callback,
});

const requestUnclaimController = (callback) => ({
  type: actions.UNCLAIM_CONTROLLER,
  callback,
});

const updateSelectedLocation = (data) => ({
  type: actions.STORE_SELECTED_LOCATION,
  payload: data,
});

const siteModalAction = (data, type, method = null, siteId, callback) => ({
  type: type,
  payload: data,
  method,
  siteId,
  callback,
});

export {
  requestSites,
  saveSelectedSite,
  requestLocations,
  requestClaimController,
  siteModalAction,
  updateSelectedLocation,
  requestUnclaimController,
  getSiteAndLocationForFavouriteController,
};
